import { c as _c } from "react/compiler-runtime";
import type { FC } from "react";
import { FormGroup } from "..";
import { TextInput } from "../../inputs";
import type { TextFormGroupProps } from "./TextFormGroup.d";

/**
 * @module TextFormGroup
 * @param {TextFormGroupProps} props
 * @returns {ReactElement<TextFormGroupProps, FC<TextFormGroupProps>>}
 */
export const TextFormGroup: FC<TextFormGroupProps> = t0 => {
  const $ = _c(20);
  let containerClassName;
  let dataId;
  let error;
  let label;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      label,
      error,
      required: t1,
      "data-testid": dataId,
      containerClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = containerClassName;
    $[2] = dataId;
    $[3] = error;
    $[4] = label;
    $[5] = props;
    $[6] = t1;
  } else {
    containerClassName = $[1];
    dataId = $[2];
    error = $[3];
    label = $[4];
    props = $[5];
    t1 = $[6];
  }
  const required = t1 === undefined ? false : t1;
  let t2;
  if ($[7] !== containerClassName || $[8] !== dataId || $[9] !== error || $[10] !== label || $[11] !== required) {
    t2 = {
      label,
      error,
      required,
      "data-testid": dataId,
      containerClassName
    };
    $[7] = containerClassName;
    $[8] = dataId;
    $[9] = error;
    $[10] = label;
    $[11] = required;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== error || $[14] !== props || $[15] !== required) {
    t3 = <TextInput {...props} error={error} required={required} />;
    $[13] = error;
    $[14] = props;
    $[15] = required;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t2 || $[18] !== t3) {
    t4 = <FormGroup {...t2}>{t3}</FormGroup>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};
export default TextFormGroup;